<template>
  <div class="admin-page">
    <div class="page-header">
      <h1 class="page-title">卡片管理</h1>
    </div>

    

    <div class="admin-card">
      <h2 class="card-title">铸造卡牌</h2>


      <div class="form-item">
        <div class="select-wrap">
          <div class="select-box" @click="toggleDropdown('contract')">
            <span class="select-text">{{ selectedContractLabel }}</span>
            <span class="chevron" :class="{ open: showContractDropdown }" />
          </div>
          <transition name="dropdown-fade">
            <div v-if="showContractDropdown" class="dropdown-panel">
              <div
                v-for="option in contractOptions"
                :key="option.value"
                class="dropdown-item"
                :class="{ active: contractType === option.value }"
                @click="selectContract(option)"
              >{{ option.label }}</div>
            </div>
          </transition>
        </div>
      </div>

      <div class="form-item">
        <div class="select-wrap">
          <div class="select-box" @click="toggleDropdown('card')">
            <span class="select-text">{{ selectedCardLabel }}</span>
            <span class="chevron" :class="{ open: showCardDropdown }" />
          </div>
          <transition name="dropdown-fade">
            <div v-if="showCardDropdown" class="dropdown-panel">
              <div
                v-for="option in cardOptions"
                :key="option.value"
                class="dropdown-item"
                :class="{ active: cardType === option.value }"
                @click="selectCard(option)"
              >{{ option.label }}</div>
            </div>
          </transition>
        </div>
      </div>

      <div class="form-item">
        <div class="input-box">
          <input v-model="quantity" type="number" placeholder="请输入数量" />
        </div>
      </div>

      <button class="action-btn" :disabled="submitting" @click="onMint">
        {{ submitting ? '提交中...' : '立即铸造' }}
      </button>
    </div>

    <div class="admin-card contract-info-card">
      <div class="info-row">
        <span class="info-label">质押合约:</span>
        <span class="info-value">{{ stakeContractAddress }}</span>
      </div>
      <button type="button" class="copy-link" @click="onCopyStakeAddress">
        复制合约
      </button>
      <div class="info-row">
        <span class="info-label">剩余RUSD:</span>
        <span class="info-value">{{ remainingRusd }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">剩余LP:</span>
        <span class="info-value">{{ remainingLp }}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Notify } from "vant";
import {
  getAdminAuthorityStatus,
  adminMintCard,
  fetchAdminTargets,
  fetchStakeContractInfo,
} from "@/contract/services/adminService";
import { STAKE_ADDRESS } from "@/contract/constants";
import { copyText } from "@/utils/utils";

export default {
  name: "AdminPage",
  data() {
    return {
      contractType: "lottery",
      cardType: 1,
      quantity: "",
      submitting: false,
      loadingAuth: false,
      isAuthorized: false,
      showContractDropdown: false,
      showCardDropdown: false,
      stakeContractAddress: STAKE_ADDRESS,
      remainingRusd: "--",
      remainingLp: "--",
      contractOptions: [
        { value: "lottery", label: "抽奖合约", address: "" },
        { value: "admin", label: "管理员自己", address: "" },
      ],
      cardOptions: [
        { value: 1, label: "金卡" },
        { value: 2, label: "银卡" },
        { value: 3, label: "铜卡" },
      ],
    };
  },
  computed: {
    ...mapGetters(["accountAddress"]),
    selectedContractLabel() {
      const option = this.contractOptions.find((item) => item.value === this.contractType);
      return option ? option.label : "抽奖合约";
    },
    selectedCardLabel() {
      const option = this.cardOptions.find((item) => item.value === this.cardType);
      return option ? option.label : "金卡";
    },
  },
  watch: {
    accountAddress: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadAuthority(value);
        } else {
          this.isAuthorized = false;
        }
      },
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
    this.loadStakeContractInfo();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    async loadStakeContractInfo() {
      try {
        const info = await fetchStakeContractInfo();
        this.stakeContractAddress = info.address;
        this.remainingRusd = info.rusdBalance;
        this.remainingLp = info.lpBalance;
      } catch (err) {
        this.remainingRusd = "--";
        this.remainingLp = "--";
      }
    },
    async onCopyStakeAddress() {
      const copied = await copyText(this.stakeContractAddress);
      if (copied) {
        Notify({ type: "success", message: "合约地址已复制" });
      } else {
        Notify({ type: "warning", message: "复制失败，请手动复制" });
      }
    },
    async loadAuthority(account) {
      this.loadingAuth = true;
      try {
        const [status, targets] = await Promise.all([
          getAdminAuthorityStatus(account),
          fetchAdminTargets(),
        ]);
        this.isAuthorized = status.isAuthorized;
        this.$store.commit("SET_ADMIN_STATUS", status.isAuthorized);
        this.contractOptions = this.contractOptions.map((item) => ({
          ...item,
          address: targets[item.value]?.address || "",
        }));
        if (this.contractType === "admin" && !this.recipient) {
          this.recipient = account;
        }
      } catch (err) {
        this.isAuthorized = false;
        this.$store.commit("SET_ADMIN_STATUS", false);
      } finally {
        this.loadingAuth = false;
      }
    },
    toggleDropdown(type) {
      if (type === "contract") {
        this.showCardDropdown = false;
        this.showContractDropdown = !this.showContractDropdown;
      } else {
        this.showContractDropdown = false;
        this.showCardDropdown = !this.showCardDropdown;
      }
    },
    selectContract(option) {
      this.contractType = option.value;
      this.showContractDropdown = false;
    },
    selectCard(option) {
      this.cardType = option.value;
      this.showCardDropdown = false;
    },
    handleOutsideClick(event) {
      const target = event.target;
      if (!this.$el.contains(target)) return;
      if (!target.closest || target.closest(".select-wrap")) return;
      this.showContractDropdown = false;
      this.showCardDropdown = false;
    },
    async onMint() {
      if (this.submitting) return;
      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先连接钱包" });
        return;
      }
      if (!this.isAuthorized) {
        Notify({ type: "danger", message: "当前钱包无管理员权限" });
        return;
      }
      try {
        this.submitting = true;
        const targetOption = this.contractOptions.find(
          (item) => item.value === this.contractType
        );
        await adminMintCard({
          to: targetOption?.address || "",
          cardType: this.cardType,
          quantity: this.quantity,
        });
        Notify({ type: "success", message: "铸造交易已提交" });
        this.quantity = "";
      } catch (err) {
        Notify({ type: "danger", message: err?.message || "铸造失败" });
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.admin-page {
  padding: 40px 30px 40px;
  box-sizing: border-box;
  color: #fff;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  margin: 0;
  font-size: 52px;
  font-weight: 600;
}

.page-desc {
  margin: 14px 0 0;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.6);
}

.admin-card {
  padding: 30px 28px 34px;
  border-radius: 24px;
  border: 1px solid rgba(115, 56, 255, 0.55);
  background: rgba(4, 10, 40, 0.92);
  box-shadow: 0 0 0 1px rgba(115, 56, 255, 0.15) inset;

  & + .admin-card {
    margin-top: 24px;
  }
}

.contract-info-card {
  .info-row {
    margin-bottom: 12px;
    font-size: 24px;
    line-height: 1.5;
    word-break: break-all;
  }

  .info-label {
    color: rgba(255, 255, 255, 0.85);
  }

  .info-value {
    margin-left: 8px;
    color: #fff;
  }

  .copy-link {
    display: inline-block;
    margin: 0 0 16px;
    padding: 0;
    border: none;
    background: none;
    color: #7338ff;
    font-size: 24px;
    cursor: pointer;
  }
}

.card-title {
  margin: 0 0 24px;
  font-size: 34px;
  font-weight: 600;
}

.form-item {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  margin-bottom: 14px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.85);
}

.select-wrap {
  position: relative;
}

.select-box,
.input-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 76px;
  padding: 0 18px;
  border-radius: 14px;
  background: #071038;
  border: 1px solid rgba(65, 98, 255, 0.55);
  box-sizing: border-box;
}

.select-text,
.input-box input {
  font-size: 24px;
  color: #fff;
}

.chevron {
  width: 12px;
  height: 12px;
  border-right: 2px solid rgba(255, 255, 255, 0.85);
  border-bottom: 2px solid rgba(255, 255, 255, 0.85);
  transform: rotate(45deg);
  transition: transform 0.2s;

  &.open {
    transform: rotate(225deg);
  }
}

.dropdown-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 10;
  overflow: hidden;
  border-radius: 14px;
  background: #0a133f;
  border: 1px solid rgba(65, 98, 255, 0.55);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.25);
}

.dropdown-item {
  padding: 16px 18px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.78);
  text-align: left;

  &.active {
    color: #7338ff;
    background: rgba(115, 56, 255, 0.12);
  }

  &:active {
    background: rgba(255, 255, 255, 0.05);
  }
}

.input-box input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
}

.input-box input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.action-btn {
  width: 100%;
  height: 92px;
  margin-top: 24px;
  border: none;
  border-radius: 46px;
  background: linear-gradient(90deg, #6d4cff 0%, #7f55ff 100%);
  color: #fff;
  font-size: 30px;
  font-weight: 600;

  &:disabled {
    opacity: 0.65;
  }
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
